import {
  GetCustomerNotesDocument,
  GetReservationActivitiesDocument,
  GetReservationDocument,
  GetReservationNotesDocument,
  GetReservationsDocument,
} from "@/graphql/graphql"

export const UPDATE_RESERVATION_REFETCH_QUERIES = [
  GetReservationsDocument,
  GetReservationDocument,
  GetReservationActivitiesDocument,
]

export const CREATE_RESERVATION_NOTE_REFETCH_QUERIES = [GetReservationNotesDocument]

export const CREATE_CUSTOMER_NOTE_REFETCH_QUERIES = [GetCustomerNotesDocument]
